
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./ThankYouScreen.css";
import logoImage from "../../assets/logo.png";           
import namasteImage from "../../assets/thankyou.png";    
import safeDayImage from "../../assets/havesafeday.png"; 

const ThankYouScreen = () => {
    const navigate = useNavigate();
    
     useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/"); 
    }, 3000);
         
             return () => clearTimeout(timer); // cleanup
  }, [navigate]);

  return (
    <div className="thankyou-container">
      {/* Top Logo and Tagline */}
      <div className="Th_header">
        <img src={logoImage} alt="Logo" className="logo-image" />
        <p className="description">Digital Tool Of Safety System</p>
      </div>

      {/* Namaste Image */}
      <div className="namaste-section">
        <img src={namasteImage} alt="Thank You" className="namaste-image" />
      </div>

      {/* Feedback Text */}
      <div className="feedback-text">
        <p className="local-lang-text">
          మీ అభిప్రాయానికి ధన్యవాదాలు. మీ ప్రతిస్పందనలు రికార్డ్ చేయబడ్డాయి.
        </p>
        <p className="thankyou-text">
          Thank you for your feedback. Your responses have been recorded.
        </p>
      </div>

      {/* Bottom Image */}
      <div className="bottom-section">
        <img src={safeDayImage} alt="Have a Safe Day" className="safe-image" />
      </div>
    </div>
  );
};

export default ThankYouScreen;
